<template>
  <div class="row">
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" :color="color" loader="dots" />
    <div class="col-12 f13">
      <div class="card concard card-shadow">
        <div class="card-header white text-center">
          <img src="@/assets/logo.png"
            style="width: 100px; border-radius: 50%;   box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;" />
          <div class="t1" style="margin: 5px">ข้อมูล ร้านค้า</div>
        </div>
        <Form @submit="onSubmitRegister" :validation-schema="register" id="kt_account_profile_details_form" class="form"
          novalidate="novalidate">
          <div class="card-body mb-47 mt-2 white">
            <!--begin::Card body-->
            <div class="card-body">

              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label fw-bold fs-6 require">ชื่อร้านค้า</label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field type="text" name="shop_name" class="form-control  form-control-solid" placeholder="ชื่อร้านค้า"
                    v-model="data_register.shop_name" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="shop_name" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>

              <div class="row mb-6">
                <label class="col-lg-4 col-form-label required fw-bold fs-6">ประเภทธุรกิจ</label>

                <div class="col-lg-8 fv-row">
                  <Field as="select" name="shop_type" class="form-control  form-control-solid"
                    @change="checkDepartment($event)" v-model="data_register.shop_type" placeholder="ประเภทธุรกิจ">
                    <option value="" selected disabled>โปรดเลือก</option>
                    <option value="ร้านอาหาร">ร้านอาหาร</option>
                    <option value="ร้านขายของชำ">ร้านขายของชำ</option>
                    <option value="Cafe ร้านกาแฟ เครื่องดื่ม">Cafe ร้านกาแฟ เครื่องดื่ม</option>
                    <option value="อื่นๆ">อื่นๆ</option>
                  </Field>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="department" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-8 fv-row mt-1" v-if="department_status">
                  <Field type="text" name="shop_type_other" class="form-control  form-control-solid"
                    placeholder="ประเภทธุรกิจ" v-model="data_register.shop_type_other" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="shop_type_other" />
                    </div>
                  </div>

                </div>

              </div>

              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label fw-bold fs-6">รายละเอียดร้านค้า <br><span
                    style="font-weight: 300 !important; color: red;">( เช่น
                    มีสินค้าประเภทใดบ้างในร้าน ..)</span></label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field as="textarea" row="8" type="text" name="shop_detail" class="form-control  form-control-solid"
                    placeholder="รายละเอียดร้านค้า" v-model="data_register.shop_detail" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="shop_detail" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>

              <div class="row mb-6">
                <!--begin::Label-->
                <label class="col-lg-4 col-form-label fw-bold fs-6">ช่องทางการติดต่อ <br><span
                    style="font-weight: 300 !important; color: red;">( เช่น
                    facebook,line,เบอร์โทรร้าน,ที่อยู่ ..)</span></label>
                <!--end::Label-->

                <!--begin::Col-->
                <div class="col-lg-8 fv-row">
                  <Field as="textarea" row="8" type="text" name="shop_contrct" class="form-control  form-control-solid"
                    placeholder="ช่องทางการติดต่อ" v-model="data_register.shop_contrct" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="shop_contrct" />
                    </div>
                  </div>
                </div>
                <!--end::Col-->
              </div>



            </div>
            <!--end::Card body-->
          </div>
          <div class="card-footer white">
            <div class="d-flex justify-center align-center">
              <div style="width: 100%; padding: 0px 5px">
                <button type="button" @click="back" class="button btn-back">
                  ย้อนกลับ
                </button>
              </div>
              <div style="width: 100%; padding: 0px 5px">
                <button type="submit" style="width: 100%" class="button">
                  ลงทะเบียน
                </button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, onMounted, inject, computed } from "vue";
import { SET_REGISTER } from "@/store/modules/RegisterModel";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import json from "@/service/DataStore.json";
import useRegister from "@/service/api/register";
import useSweetalert from "@/service/sweetalert2";
import liff from "@line/liff";
export default defineComponent({
  name: "Register",
  components: {
    ErrorMessage,
    Field,
    Form,
    Loading,
  },
  setup() {
    const store = inject("store");
    const router = inject("router");
    const { Sconfirm, SconfirmNc, SToast } = useSweetalert();
    const { Register } = useRegister();
    const items = ref(json);
    let isLoading = ref(false);
    let color = ref(process.env.VUE_APP_COLOR);
    const data_register = store.getters.getRegister;

    let department_status = ref(false);

    const register = Yup.object().shape({
      shop_type: Yup.string().required("กรุณาเลือก ประเภทธุรกิจ"),
      shop_type_other: Yup.string()
        .when("shop_type", {
          is: (shop_type) => shop_type === "อื่นๆ",
          then: Yup.string().required("กรุณากรอก ประเภทธุรกิจ"),
        }),
      shop_name: Yup.string().required("กรุณากรอก ชื่อร้านค้า"),
      shop_detail: Yup.string().required("กรุณากรอก รายละเอียดร้านค้า"),
      shop_contrct: Yup.string().required("กรุณากรอก ช่องทางการติดต่อ")
    });

    const uniqueProvince = computed(() => {
      return items.value.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.province]: current,
        });
      }, {});
    });

    const uniqueAmphoe = computed(() => {
      let dd = items.value.filter(
        (item) => item.province === data_register.province
      );
      return dd.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.amphoe]: current,
        });
      }, {});
    });

    const uniqueDistrict = computed(() => {
      let dd = items.value.filter(
        (item) => item.amphoe === data_register.amphoe
      );
      return dd.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.district]: current,
        });
      }, {});
    });

    function setZipcode(val) {
      let result = val;

      let data = items.value.filter(
        (item) =>
          item.district === result && item.amphoe === data_register.amphoe
      );
      data_register.zipcode = data[0].zipcode;
    }

    const back = () => {
      router.push({ name: "Register_1" });
    };

    onMounted(() => {
      if (!store.getters.getAccessToken.accesstoken) {
        router.push({ name: "Home" });
      }
    });

    function checkDepartment(event) {
      if (event.target.value === "อื่นๆ") {
        department_status.value = true;
      } else {
        department_status.value = false;
      }
    }

    const onSubmitRegister = (values) => {
      store.dispatch(SET_REGISTER, values);


      console.log(store.getters.getRegister);

      Sconfirm("ยืนยัน การลงทะเบียน", "question").then(async (result) => {
        if (result.isConfirmed) {
          isLoading.value = true;

          await Register(store.getters.getRegister)
            .then((result) => {
              isLoading.value = false;
              if (result.data.status === "success") {
                SconfirmNc("ลงทะเบียนสำเร็จ", "success", "ตกลง").then(() => {
                  liff.ready.then(() => {
                    liff.closeWindow();
                  });
                });
              } else {
                SconfirmNc("ไม่มีสิทธิ์เข้าใช้งาน", "error", "ตกลง").then(
                  () => {
                    liff.ready.then(() => {
                      liff.closeWindow();
                    });
                  }
                );
              }
            })
            .catch((error) => {
              if (error.response) {
                let errors = error.response.data.errors;

                if (errors.id_line) {
                  SToast("error", `${errors.id_line[0]}`);
                } else {
                  SToast("error", "เกิดข้อผิดผาด กรุณาลองใหม่อีกครั้ง");
                }
              }
            });
        }
      });
    };

    return {
      back,
      onSubmitRegister,
      register,
      data_register,
      isLoading,
      color,
      uniqueProvince,
      uniqueAmphoe,
      uniqueDistrict,
      setZipcode,
      checkDepartment,
      department_status,
    };
  },
});
</script>

<style scoped>
.icon {

  width: 50px;
  padding: 5px;
}

.gender {
  padding: 30px 20px;
  border: 1px solid #dee2e6;
}

input[type="radio"] {
  display: none;
}

input:checked+span {
  color: var(--color);
  border: 2px solid var(--color);
}
</style>
